import { render, staticRenderFns } from "./ReceptionVerification.vue?vue&type=template&id=63b0fc44&scoped=true"
import script from "./ReceptionVerification.vue?vue&type=script&lang=js"
export * from "./ReceptionVerification.vue?vue&type=script&lang=js"
import style0 from "./ReceptionVerification.vue?vue&type=style&index=0&id=63b0fc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0fc44",
  null
  
)

export default component.exports